module.exports = __webpack_public_path__ + "img/loader.673b4cb9.svg";